import axios from "axios";
import { Message } from "element-ui";

const BaseURL = process.env.VUE_APP_BASE_API; //默认路径

class Rest {
  constructor() {
    this.client = axios.create();
    this.client.defaults.baseUrl = BaseURL;
    this.client.defaults.withCredentials = true;
    this.client.defaults.headers.post["Content-Type"] =
      "application/x-www-form-urkencoded";
    // this.client.defaults.headers.code = 'FFE3D4A23DA7CC9091773704DE7CBB8B'
    this.client.defaults.timeout = 10000;
  }

  get(url, params) {
    return this.client.get(BaseURL + url, {
      params: params,
    });
  }

  post(url, params) {
    return this.client
      .post(BaseURL + url, params)
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("******");
        console.log(err);
        return Promise.reject(err);
      });
  }

  put(url, params) {
    return this.client
      .put(BaseURL + url, params)
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  }

  delete(url) {
    return this.client.delete(url);
  }

  login(url, body, params) {
    return this.client
      .post(BaseURL + url, body, params)
      .then((res) => {
        this.client.defaults.headers.common["token"] = res.data.token;
        this.setToken(res.data.token);
        return Promise.resolve(res);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  }

  logout() {
    this.client.defaults.headers.common["token"] = "";
  }

  getAxios() {
    return this.client;
  }
}
let rest = new Rest();

// requese拦截器
rest.getAxios().interceptors.request.use(
  (config) => {
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

//response拦截器
rest.getAxios().interceptors.response.use(
  (res) => {
    return res.data;
  },
  (err) => {
    console.log(err.response);
    if (err.response.status === 500 || err.response.status === 400) {
      if (err.response.data.handleWay === "Input") {
        return Promise.reject(err.response);
      } else if (err.response.data.handleWay === "Dialog") {
        Message({
          showClose: true,
          message: err.response.data.message,
          type: "error",
          duration: 3000,
        });
      } else if (err.response.data.handleWay === "Console") {
        console.log(err.response.data.message);
      }
    } else if (err.response.status === 502) {
      Message({
        showClose: true,
        message: "服务器错误" + err.response.data.message,
        type: "error",
        duration: 3000,
      });
    }
    return Promise.reject(err.response);
  }
);

export default rest;
